var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-card',{staticClass:"mx-auto mb-8",attrs:{"width":"1150","elevation":"16"}},[_c('v-img',{attrs:{"cover":"","height":"250","src":_vm.post.image}}),_c('v-card-item',[_c('v-card-subtitle',[_vm._v(_vm._s(_vm.post.date))]),_c('v-card-title',[_vm._v(_vm._s(_vm.post.title))])],1),_c('v-card-text',[_vm._v(_vm._s(_vm.post.content))])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }